module.exports = __webpack_public_path__ + "static/media/404.a4b23e68.png";